

import { mapState, mapMutations } from 'vuex'
export default{
  data(){
    return{
      list:null,
      showpath: "",
      current: 0,
      showLoading: true,
    }
  },
  watch: {
    show: {
      handler(newv, oldv) {
        if(newv){
          this.stopAudio()
        }
        if (newv && this.$refs.videoSwi) {
          this.playCurr(0)
        } else {
          if(!newv){
            this.hide()
          }
        }
      }, immediate: true
    },
  },
  
  mounted() {
    // this.getDetail()
    this.stopAudio()
    if(!this.newlist){
      console.log('MOUNTEND',this.newlist)
      this.getDetail();
    }
  },
  methods: {
    ...mapMutations(['audio/updatePlayState']),
    onChange(index) {
      this.current = index
      this.playCurr(index)
    },

    playCurr(index) {
      this.showLoading = false;
      let that = this;
      this.list.map((t, i) => {
        if (i == index) {
          document.getElementById(`${this.idName}${i}`).currentTime = 0
          document.getElementById(`${this.idName}${i}`).play()
          let elevideo = document.getElementById(`${this.idName}${i}`);
          elevideo.addEventListener('ended', function () { //结束
            console.log("播放结束");
            // that.menuClick('home')
            that.playEnd()
        }, false);
        } else {
          document.getElementById(`${this.idName}${i}`).pause()
        }
      })
    },

    stopAudio() {
      this['audio/updatePlayState'](false)
    },

    hide() {
      this.$emit("hide")
      setTimeout(() => {
        this.$refs.videoSwi && this.$refs.videoSwi.swipeTo(0)
        this.current = 0
        setTimeout(() => {
          this.list.map((t, i) => {
            document.getElementById(`${this.idName}${i}`)  && document.getElementById(`${this.idName}${i}`).pause()
          })
        }, 300);
      }, 300);
    },

    loadEnd(e) {
      this.showLoading = true
    },
    videoPlay(e) {
      this.showLoading = false;
    }


  },
}